/**
 * Rellax Parallax Initialization
 * Simple and clean parallax effect using Rellax.js
 * Disabled on mobile to avoid performance issues and overlapping content
 */
import Rellax from 'rellax';

let rellaxInstance = null;

function initParallax() {
    if (document.querySelectorAll('.beurs-parallax').length > 0) {
        const mobileBreakpoint = window.matchMedia('(min-width: 768px)');
        
        if (mobileBreakpoint.matches) {
            if (rellaxInstance) {
                rellaxInstance.destroy();
            }
            rellaxInstance = new Rellax('.beurs-parallax', {
                speed: 2
            });
        }
    }
}

// Initialize on page load
initParallax();

// Reinitialize on responsive resize
window.addEventListener('responsiveResize', () => {
    initParallax();
});